module.exports = __webpack_public_path__ + "img/GERA_Home_Background_Mobile.jpg";